













































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCrfsMuban } from "@/request/projects";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../../sjzx/modules/zbsjk/components/nav-left.vue";
import CustomCmp from "../../views/project-create-third/customCmp.vue";
import ControlCmp from "../../views/project-create-third/controlCmp.vue";
import SystemCmp from "../../views/project-create-third/systemCmp.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
    CustomCmp,
    ControlCmp,
    SystemCmp,
  },
})
export default class ProjectCrfEdit extends Vue {
  private title: any = "";
  private id: any = "";
  private cTemplate: any = {};
  private cFangshi: any = {};
  private cState: any = "custom";
  /**
   * @description 处理当前右边显示部分变化
   */
  private handleCStateChange(val: any) {
    this.cState = val;
  }
  /**
   * @description 获取模板内容
   */
  private GetMuban() {
    const params = {
      params: {
        template_id: this.id,
      },
    };
    GetCrfsMuban(this, params).then((res) => {
      this.cTemplate = res;
      this.cFangshi = {
        group_id: this.cTemplate.group_id,
        interview_id: this.cTemplate.interview_id,
        project_id: this.cTemplate.project_id,
        访视名称: this.cTemplate["访视名称"],
      };
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (!this.$route.query.template_id) {
      this.$message.error("参数有误");
      this.$router.back();
      return;
    }
    this.id = this.$route.query.template_id;
    this.title = this.$route.query.title;
    this.GetMuban();
  }
}
